import {createAsyncAction} from "typesafe-actions";
import ActionType from "../PaymentHistory/ActionType";
import {PaymentHistoryListModel, PaymentHistoryRequestModel} from "../../model/PaymentModel";

export const getPaymentHistory = createAsyncAction(
    ActionType.GET_PAYMENT_HISTORY_REQUEST,
    ActionType.GET_PAYMENT_HISTORY_SUCCEEDED,
    ActionType.GET_PAYMENT_HISTORY_FAILED
)<PaymentHistoryRequestModel, PaymentHistoryListModel, Error>();
